"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Super/SuperNerdScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _log = require('shared/log');

var _Form = require('web/components/Form');

const SuperNerdScreen = () => {
  const [command, setCommand] = _react.useState.call(void 0, 'GetInbox')
  const [parameters, setParameters] = _react.useState.call(void 0, '{}')
  const [result, setResult] = _react.useState({})
  const [error, setError] = _react.useState({})
  // Empty until the first run, as in the class.
  const [time, setTime] = _react.useState(undefined)
  const [size, setSize] = _react.useState(undefined)

  const submit = () => {
    setSize(0)
    setTime(0)
    setResult({})
    setError({})

    let data
    try {
      data = JSON.parse(parameters)
    } catch (e) {
      _log.log.error(new Error("Superuser doesn't know how to JSON"))
      setTime(0)
      setSize(0)
      setResult({})
      // SAFETY: JSON.parse only throws SyntaxError.
      setError((e ).message)
      return
    }

    const start = Date.now()
    _client2.default.send(command, data).then((r) => {
      setTime(Date.now() - start)
      setSize(JSON.stringify(r).length)
      setResult(r)
      setError({})
    }).catch((e) => {
      _log.log.error(e)
      setTime(Date.now() - start)
      setSize(0)
      setResult({})
      setError(e)
    })
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Command")
        , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
          , _react2.default.createElement(_Form.TextInput, {
            placeholder: "GetInbox",
            value: command,
            onChange: e => setCommand(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
          )
        )
        , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Parameters", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
          , _react2.default.createElement(_Form.TextInput, {
            placeholder: "{}",
            value: parameters,
            onChange: e => setParameters(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
          )
        )
        , _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 68}} )
        , _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 69}} )
        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, _react2.default.createElement('button', { onClick: submit, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, "Go"))
      )
      , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
        , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}, "Time")
        , _react2.default.createElement('pre', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}, time, " ms" )
        , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}, "Size")
        , _react2.default.createElement('pre', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}, size, " chars" )
        , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}, "Result")
        , _react2.default.createElement('pre', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}, JSON.stringify(result, null, 2))
        , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, "Error")
        , _react2.default.createElement('pre', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}, JSON.stringify(error, null, 2))
      )
    )
  )
}

exports. default = SuperNerdScreen
